import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';
import { useGlobalComponent } from '@rhino-project/core/hooks';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';

export const CellBooleanBase = ({
  trueText,
  falseText,
  empty = '-',
  ...props
}: TableInheritedProps & {
  trueText?: string;
  falseText?: string;
  empty?: string;
}) => {
  const { t } = useTranslation();
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const value = useMemo(() => {
    if (getValue!() == null) return empty;

    return getValue!()
      ? (trueText ?? t('rhino.frontend.messages.yes'))
      : (falseText ?? t('rhino.frontend.messages.no'));
  }, [empty, getValue, trueText, falseText, t]);

  return <div {...inheritedProps}>{value}</div>;
};

export const CellBoolean = (props: TableInheritedProps) =>
  useGlobalComponent('CellBoolean', CellBooleanBase, props);
